import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-4.webp";
import ChooseaiImage from "../images/comp/choose_ai_img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import qualityIcon from "../images/Quality.png";
import developmentIcon from "../images/development.png";
import ux_icon from "../images/ux_icon.png";
import testingIcon from "../images/Testing.png";
import supportIcon from "../images/Support.png";
import launchIcon from "../images/Deployment & Launch.png";

const ApiDevelopmentPage = () => {
  const heroBannerData = {
    subtitle: "API Development",
    title: "APIs That Connect. APIs That Deliver.",
    description:
      "At Hope Web Solutions, we build powerful, scalable, and secure APIs that connect your applications, systems, and third-party services. Whether it's creating a custom API from scratch or integrating with existing ones, we ensure seamless communication and data exchange—empowering your digital infrastructure to perform efficiently and reliably.",
    buttonText: "Contact now",
    buttonLink: "/contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Custom API Development",
      description:
        "Designing and building secure, scalable, and high-performance APIs tailored to your unique business logic and requirements.",
      icon: researchIcon,
    },
    {
      title: "RESTful API Services",
      description:
        "Creating clean and efficient RESTful APIs that enable smooth data exchange between front-end and back-end systems.",
      icon: planningIcon,
    },
    {
      title: "Third-Party API Integration",
      description:
        "Seamless integration with popular third-party services like payment gateways, CRMs, social media platforms, and more.",
      icon: designIcon,
    },
    {
      title: "API for Mobile Applications",
      description:
        "Building lightweight, fast APIs for Android and iOS apps to ensure reliable mobile experiences.",
      icon: developmentIcon,
    },
    {
      title: "Authentication & Security",
      description:
        "Implementing secure protocols like OAuth, JWT, and API key authentication to protect your systems and data.",
      icon: qualityIcon,
    },
    {
      title: "API Documentation & Support",
      description:
        "Delivering well-documented APIs with clear endpoints, usage guidelines, and ongoing technical support.",
      icon: supportIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Gathering",
      description:
        "Understanding your business needs, target audience, and goals to define the website’s scope.",
      icon: researchIcon,
    },
    {
      title: "API Design",
      description:
        "Structuring endpoints, request/response models, and data formats for optimal performance and clarity.",
      icon: designIcon,
    },
    {
      title: "Development & Testing",
      description:
        "Coding the API using modern programming languages and frameworks to ensure performance, security, and reliability.",
      icon: developmentIcon,
    },
    {
      title: "Integration",
      description:
        "Connecting the API with your existing systems, applications, or third-party services.",
      icon: testingIcon,
    },
    {
      title: "Security Implementation",
      description:
        "Implementing secure protocols like OAuth, JWT, and API key authentication to protect your systems and data.",
      icon: qualityIcon,
    },
    {
      title: "Documentation & Deployment",
      description:
        "Creating comprehensive API documentation and deploying the API to your preferred platform.",
      icon: testingIcon,
    },
    {
      title: "Deployment & Launch",
      description:
        "We deploy the final product on your preferred platform with full support, ensuring a smooth and successful launch.",
      icon: launchIcon,
    },
    {
      title: "Maintenance & Support",
      description:
        "Post-launch, we provide ongoing updates, performance monitoring, and technical support to keep your system running optimally.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Websolution?",
    image: ChooseaiImage,
    imageAlt: "Ui/Ux",
    items: [
      {
        label: "Plannings",
        text: "Hope Web Solutions is a leading API Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional API solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in API development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">API Development Services</h2>
              <p className="sub-title text-black pt-2">
                We offer comprehensive API development and integration services
                that support modern applications across web, mobile, and cloud
                platforms.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="API Development Process"
        subtitle="Our step-by-step API development process ensures quality, security, and scalability from start to finish."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default ApiDevelopmentPage;
